"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.domain = void 0;
var qs = require('qs');
exports.domain = function (axios) {
    return {
        //도메인 등록
        postDomains: function (request) {
            var query = qs.stringify(request.params);
            return axios.post("/domains?" + query, request.data);
        },
        //도메인 유효성 여부 검색
        getDomainsCheckAvailability: function (request) {
            var query = qs.stringify(request.params);
            return axios.get("/domains/check-availability?" + query);
        },
        //도메인 연결 신청
        postDomainsConnect: function (request) {
            var query = qs.stringify(request.params);
            return axios.post("/domains/connect?" + query, request.data);
        },
        //도메인 연장
        postDomainsExtensions: function (request) {
            var query = qs.stringify(request.params);
            return axios.post("/domains/extensions?" + query, request.data);
        },
        //도메인 상세 조회
        getDomainsDomainNo: function (request) {
            return axios.get("/domains/" + request.pathParams.domainNo);
        },
        // 주문한 도메인 정보 조회
        getDomainsOrdersOrderNo: function (request) {
            return axios.get("/domains/orders/" + request.pathParams.orderNo);
        },
        //도메인 연결 해지 신청
        deleteDomainsDomainNoDisconnect: function (request) {
            return axios.delete("/domains/" + request.pathParams.domainNo + "/disconnect");
        },
        //도메인에 해당하는 SSL 보안서버 상세 조회
        getDomainsDomainNoSsl: function (request) {
            return axios.get("/domains/" + request.pathParams.domainNo + "/ssl");
        },
        //도메인에 해당하는 SSL 사용설정 및 인증씰 수정
        putDomainsDomainNoSsl: function (request) {
            return axios.put("/domains/" + request.pathParams.domainNo + "/ssl", request.data);
        },
        //도메인에 해당하는 인증씰 수정 및 사용 설정
        putDomainsDomainNoTrustSeal: function (request) {
            return axios.put("/domains/" + request.pathParams.domainNo + "/trust-seal", request.data);
        },
        // 도메인 기관 리스트 조회
        getDomainsTypes: function () {
            return axios.get('/domains/types');
        },
        // 네임서버 조회
        getDomainsDomainNameServer: function (request) {
            return axios.get("/domains/" + request.pathParams.domain + "/name-server");
        },
        // 레코드 추가
        postDomainsRecords: function (request) {
            return axios.post('/domains/records', request.data);
        },
        // 서브 도메인 조회
        getDomainsDomainNoSubDomains: function (request) {
            return axios.get("/domains/" + request.pathParams.domainNo + "/sub-domains");
        }
    };
};
